import React from "react";
import configData from "../../../config.json";
import { useMediaQuery } from "react-responsive";

function DailyStory({ setExpand, setSelected }) {
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1023px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const wrapper = {
    marginLeft: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    marginRight: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    paddingLeft: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    paddingRight: isMobile ? "12px" : "16px",
    paddingBottom: isMobile ? "20px" : "50px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: isMobile ? "16px" : "30px",
    marginBottom: "50px",
    maxHeight: isMobile ? "calc(100vh - 120px)" : "calc(100vh - 80px)",
    overflowY: "auto",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={wrapper}>
        <div
          style={{
            fontSize: "12px",
            fontWeight: "600",
            color: configData.THEME_COLORS.PRIMARY,
            cursor: "pointer",
          }}
          onClick={() => {
            setSelected(false);
            setExpand(true);
          }}
        >
          Back
        </div>

        <div
          style={{
            marginTop: "10px",
            fontSize: isMobile ? "18px" : isTabScreen ? "20px" : "24px",
            fontWeight: "600",
            color: configData.THEME_COLORS.SECONDARY,
          }}
        >
          Daily Story
        </div>

        <div
          style={{
            fontSize: isMobile ? "22px" : isTabScreen ? "28px" : "32px",
            fontWeight: "600",
            alignSelf: "center",
            marginTop: isMobile ? "20px" : "30px",
            textAlign: "center",
            paddingRight: isMobile ? "8px" : 0,
          }}
        >
          Swami Vivekananda
        </div>

        <div
          style={{
            marginTop: isMobile ? "16px" : "30px",
            alignSelf: "center",
            fontSize: isMobile ? "14px" : isTabScreen ? "15px" : "20px",
            fontWeight: "400",
            width: isMobile ? "100%" : "95%",
            lineHeight: isMobile ? 1.6 : 1.7,
            paddingRight: isMobile ? "4px" : 0,
            wordBreak: "break-word",
          }}
        >
          Vivekananda, original name Narendranath Datta, Datta also spelled
          Dutt, (born January 12, 1863, Calcutta [now Kolkata]—died July 4,
          1902, near Calcutta), Hindu spiritual leader and reformer in India who
          attempted to combine Indian spirituality with Western material
          progress, maintaining that the two supplemented and complemented one
          another. His Absolute was a person’s own higher self; to labour for
          the benefit of humanity was the noblest endeavour. Always stressing
          the universal and humanistic side of the Vedas, the oldest sacred
          texts of Hinduism, as well as belief in service rather than dogma,
          Vivekananda attempted to infuse vigour into Hindu thought, placing
          less emphasis on the prevailing pacifism and presenting Hindu
          spirituality to the West. He was an activating force in the movement
          to promote Vedanta philosophy (one of the six schools of Indian
          philosophy) in the United States and England. In 1893 he appeared in
          Chicago as a spokesman for Hinduism at the World’s Parliament of
          Religions and so captivated the assembly that a newspaper account
          described him as “an orator by divine right and undoubtedly the
          greatest figure at the Parliament.” Thereafter he lectured throughout
          the United States and England, making converts to the Vedanta
          movement.On his return to India with a small group of Western
          disciples in 1897, Vivekananda founded the Ramakrishna Mission at the
          monastery of Belur Math on the Ganges (Ganga) River near Calcutta (now
          Kolkata). Self-perfection and service were his ideals, and the order
          continued to stress
        </div>
      </div>
    </div>
  );
}

export default DailyStory;
